import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError("خطأ في البريد الإلكتروني أو كلمة المرور. حاول مرة أخرى.");
    } finally {
      setLoading(false);
    }
  }; 

  return (
    <div className="min-h-screen bg-[#060607] text-white flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md rounded-[32px] border border-white/10 bg-[#111112]/95 p-8 shadow-[0_24px_80px_rgba(0,0,0,0.35)] backdrop-blur-xl">
        <div className="mb-8 text-center">
          <div className="text-sm uppercase tracking-[0.35em] text-zinc-500 mb-3">Admin Login</div>
          <h1 className="text-3xl font-black text-white">تسجيل الدخول</h1>
          <p className="mt-2 text-sm text-zinc-400">ادخل بيانات المسؤول للوصول إلى لوحة التحكم.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <label className="block text-xs uppercase tracking-[0.3em] text-zinc-400">
            البريد الإلكتروني
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-2 w-full rounded-2xl border border-white/10 bg-[#0d0d0f] px-4 py-3 text-sm text-white outline-none transition focus:border-[#F28C18]"
            />
          </label>

          <label className="block text-xs uppercase tracking-[0.3em] text-zinc-400">
            كلمة المرور
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-2 w-full rounded-2xl border border-white/10 bg-[#0d0d0f] px-4 py-3 text-sm text-white outline-none transition focus:border-[#F28C18]"
            />
          </label>

          {error && <p className="text-sm text-rose-400">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-2xl bg-[#F28C18] px-4 py-3 text-sm font-black uppercase tracking-[0.3em] text-black transition hover:bg-white disabled:cursor-not-allowed disabled:opacity-70"
          >
            {loading ? "جارٍ تسجيل الدخول..." : "تسجيل دخول"}
          </button>
        </form>

        <div className="mt-6 text-center text-xs text-zinc-500">
          <Link to="/" className="text-[#F28C18] hover:text-white">العودة إلى الصفحة الرئيسية</Link>
        </div>
      </div>
    </div>
  );
}
